import _ from 'lodash';
import { createSelector } from 'reselect';

const usersKey="payCitationState";

export const getPayCitationState = (state) => _.get(state, usersKey);
export const getAmericanStatesList = createSelector(getPayCitationState, (state) => _.get(state, 'americanStateList'));
export const getBararTokensList = createSelector(getPayCitationState, (state) => _.get(state, 'bearerTokenlist'));


